// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2SiZOygupNRs09zm3TBbLj"};